export default "__VITE_ASSET__CtXafqBe__"